module.exports = __webpack_public_path__ + "assets/devices/FLD-550-PG2-17315778c99c2752cd5950c6747198e9.svg";